import { HTTP } from '@community_dev/requests'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'
import { route } from 'utils/router'

export function createCustomDomain({
  client_id,
  domain,
  reuse_existing_domain,
}: {
  client_id: string
  domain: string
  reuse_existing_domain?: boolean
}) {
  return request(route(ENDPOINTS.ADMINS.CUSTOM_DOMAIN, { client_id }), {
    method: HTTP.POST,
    body: reuse_existing_domain ? { domain, reuse_existing_domain } : { domain },
  }).then(({ data }) => data)
}

export function deleteCustomDomain({ client_id }: { client_id: string }) {
  return request(route(ENDPOINTS.ADMINS.CUSTOM_DOMAIN, { client_id }), {
    method: HTTP.DELETE,
  })
}

export function verifyCustomDomain({ client_id }: { client_id: string }) {
  return request(route(ENDPOINTS.ADMINS.CUSTOM_DOMAIN_VERIFY, { client_id }), {
    method: HTTP.POST,
  }).then(({ data }) => data)
}
